(() => {
	document.addEventListener('pageLoad', () => {
		const modals = Array.from(document.querySelectorAll('.w-modal'));
		if( modals.length === 0 ) {
			return;
		}
		
		const classes = {
			body: 'has-modal',
			modal: 'is-shown',
		};
		
		const _open = (modal) => {
			document.body.classList.add(classes.body);
			modal.classList.add(classes.modal);
		};
		
		const _close = (modal) => {
			document.body.classList.remove(classes.body);
			modal.classList.remove(classes.modal);
		};
		
		modals.forEach(modal => {
			const modalId = modal.getAttribute('id');
			const triggers = Array.from(document.querySelectorAll('[data-modal='+ modalId +']'));
			triggers.forEach(trigger => {
				trigger.addEventListener('click', event => {
					event.preventDefault();
					_open(modal);
				});
			});
			
			const closeBtns = Array.from(modal.querySelectorAll('.w-modal--close, .w-modal--close-x'));
			closeBtns.forEach(closeBtn => {
				closeBtn.addEventListener('click', event => {
					event.preventDefault();
					_close(modal);
				});
			});
		});
	});
})();